import { render, staticRenderFns } from "./Wordpress02.vue?vue&type=template&id=0d1a2ebe&scoped=true"
import script from "./Wordpress02.vue?vue&type=script&lang=js"
export * from "./Wordpress02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a2ebe",
  null
  
)

export default component.exports